import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CoreTranslationService} from '../../../../@core/services/translation.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {

  selectedLanguage: any;
  @Output() languageChange = new EventEmitter<any>();

  constructor(private coreTranslationService: CoreTranslationService, public translateService: TranslateService) {
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.selectedLanguage = this.coreTranslationService.getActiveLang();
    });
  }

  setLanguage(language): void {
    // Set the selected language for the navbar on change
    this.selectedLanguage = language;
    this.coreTranslationService.setActiveLang(language);

    // Use the selected language id for translations
    this.translateService.use(language);
    this.languageChange.emit(language);
  }

}
